import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GeneralSettingsService } from '../../../../../services/general-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../../services/toast.service';
import { IAirlineDesignator } from '../../../../../shared/models/airline-designator.model';

@Component({
  selector: 'app-add-edit-airline-designators-dialog',
  templateUrl: './add-edit-airline-designators-dialog.component.html',
  styleUrls: ['./add-edit-airline-designators-dialog.component.scss']
})
export class AddEditAirlineDesignatorsDialogComponent implements OnInit {

  form?: UntypedFormGroup;
  isBusy = false;
  @Input() airlineDesignator?: IAirlineDesignator;
  @Input() title?: string;
  constructor(private generalSettingsService: GeneralSettingsService, private activeModal: NgbActiveModal, private toastService: ToastService) { }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      code: new UntypedFormControl(this.airlineDesignator?.code || '', Validators.required),
      description: new UntypedFormControl(this.airlineDesignator?.description || '', Validators.required),
      allowForSsim: new UntypedFormControl(this.airlineDesignator?.allowForSsim || false),
      allowAcOperation: new UntypedFormControl(this.airlineDesignator?.allowAcOperation || false),
    });
  }

  closeModal(reason?: any) {
    this.activeModal.dismiss(reason);
  }

  onSaveClick() {
    const data = { ...this.form.value, id: this.airlineDesignator?.id };
    this.isBusy = true;
    this.generalSettingsService.saveAirlineDesignator(data).subscribe((result) => {
      if(result?.id) {
        this.toastService.showSuccess("Airline code has been saved");
        this.closeModal(true);
      }
      this.isBusy = false;
    });
  }

}
